import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  // If user is not logged in → save path for redirect after login
  if (!currentUser) {
    localStorage.setItem("redirectAfterLogin", location.pathname);
    console.log("ProtectedRoute currentUser:", currentUser);

    return <Navigate to="/login" replace />;
  }
  console.log("ProtectedRoute.jsx file loaded");


  return children;
};

export default ProtectedRoute;
